import Render from '@Views/root/parameters/confirmation.html'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IConfiguration, IBreadcrumbItem, IUser } from '@Store/types'
import { IDropdownItem, InputDocument } from '@Components/index'
import { PackType, ReminderType } from '@Enums/index'
import { SmsHelper, EnumsHelper } from '@Helpers/index'
import { breadcrumb, office, user } from '@Store/modules'

@Render
@Component({})
export class Confirmation extends Vue {

	private confirmationTextWarning: boolean = false
	private longestAddress: string = ''
	private longestZipcode: string = ''
	private longestCity: string = ''
	private confirmations: ReminderType[] = [ReminderType.None, ReminderType.OnlyMail, ReminderType.OnlySms, ReminderType.Both]

	@Prop() configuration: IConfiguration

	//#region getters
	get user(): IUser {
		return user.user
	}
	get canSendSms(): boolean {
		return this.configuration.confirmation_type === ReminderType.Both || this.configuration.confirmation_type === ReminderType.OnlySms
	}
	get canSendMail(): boolean {
		return this.configuration.confirmation_type === ReminderType.Both || this.configuration.confirmation_type === ReminderType.OnlyMail
	}
	get types(): IDropdownItem[] {
		let result: IDropdownItem[] = []
		this.confirmations.forEach (type => result.push({value: type, label: EnumsHelper.confirmationToString(type)}))
		return result
	}
	get confirmationTextLength(): string {
		let length: number = this.computeReminderTextLength()
		return this.$i18n.tc('vm.root.parameters.confirmation.remaining-characters', length).toString()
	}
	get confirmationError(): boolean {
		return this.confirmationTextWarning
	}
	get confirmationErrorMessage(): string {
		if (this.confirmationTextWarning)
			return this.$i18n.t('vm.root.parameters.confirmation.error.too-long').toString()

		return ''
	}
	get to(): {name: string, params: {pack: PackType}} {
        return {name: 'purchase-pack', params: {pack: PackType.Sms}}
	}
	get lightOptions(): any {
        return InputDocument.superLightOptions()
    }
	//#endregion

	mounted() {
		this.$emit('navigate', 'confirmation')
		breadcrumb.updateLinked(false)
		this.initializeBreadcrumb()
		this.computeLongestLocalities()
	}

	private computeReminderTextLength(): number {
		if (!this.configuration || !this.configuration.confirmation_text) return 160

		this.configuration.confirmation_text = this.configuration.confirmation_text.trim()

		let key_word: string = "{cabinet.adresse}"
		let text: string = this.configuration.confirmation_text.replace(key_word, this.longestAddress)
		key_word = "{cabinet.code_postal}"
		text = text.replace(key_word, this.longestZipcode)
		key_word = "{cabinet.ville}"
		text = text.replace(key_word, this.longestCity)
		let count: number = SmsHelper.countOccurence(text)
		let result: number = 160 - text.length - count
		this.confirmationTextWarning = result < 0
		return result
	}

	private computeLongestLocalities() {
		for(let o of office.offices) {
			if (!o.coordinates.address) continue

			this.longestAddress = this.computeLongestAddress(o.coordinates.address, 'formatted', this.longestAddress)
			this.longestZipcode = this.computeLongestAddress(o.coordinates.address, 'zipcode', this.longestZipcode)
			this.longestCity = this.computeLongestAddress(o.coordinates.address, 'city', this.longestCity)
		}
	}

	private computeLongestAddress(address: any, property: string, max: string): string {
		if (address[property] === undefined) return max
		if (address[property].length <= max.length) return max

		return address[property]
	}

	private initializeBreadcrumb(): void {
		let item1: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.parameters').toString(), link: "parameters-main"}
		let item2: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.confirmation').toString() }
		breadcrumb.updateItems([item1, item2])
	}
}
